import { ReactElement } from 'react';
import styles from './Banner.module.scss';

type Props = {
  subheadline: string;
  bannerHeadline: string;
  bannerImageUrl: string;
  bannerMobileImageUrl?: string;
  textColor?: string;
  textAlign?: string;
};

function PromoBanner({
  subheadline,
  bannerHeadline = 'Energize with Plant-Powered Recipes',
  bannerImageUrl,
  bannerMobileImageUrl,
  textColor = 'black',
  textAlign = 'right',
}: Props): ReactElement {
  const textStyle = {
    color: textColor,
    textAlign: textAlign as 'left' | 'right',
    left: textAlign === 'left' ? '3%' : 'auto',
    right: textAlign === 'left' ? 'auto' : '5%',
  };
  return (
    <div className={styles.banner_template}>
      <picture>
        {bannerMobileImageUrl && <source media="(max-width: 430px)" srcSet={bannerMobileImageUrl} />}
        <img src={bannerImageUrl} className={styles.img_style} alt="" />
      </picture>
      <div className={styles.subheadline} style={textStyle}>
        {subheadline}
      </div>
      <div className={styles.headline} style={textStyle}>{bannerHeadline}</div>
    </div>
  );
}

export default PromoBanner;
